import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setRoomToJoin, setUserToUnfocus } from "../../store/ProductivitySessionSlice";
import { stopUserSessionAndJoinRoom } from "../../store/ProductivitySessionThunks";
import "./EndSession.css";
import { useTranslation } from "react-i18next";
const EndSession = ({ onClose }) => {
    const dispatch = useDispatch();
    const {
        roomToJoin,
        userToUnfocus
    } = useSelector((state) => state.productivitySession);

    const { t } = useTranslation();
    const enterRoom = async () => {

        if (roomToJoin && userToUnfocus) {
            const data = {
                targetRoomId: roomToJoin,
                userEmail: userToUnfocus
            }
            await dispatch(stopUserSessionAndJoinRoom({
                body: data
            }))
            onClose();
        }
    }
    const leaveAlone = () => {
        dispatch(setRoomToJoin(null));
        dispatch(setUserToUnfocus(null));
        onClose();
    }
    return (
        <>
            <div className="session-content-text">
                <span className="session-title">
                    {t("session_in_progress")}
                </span>
                <span className="session-subtitle">
                    {t("session_enter_subtitle")}
                </span>
            </div>
            <div className="session-button-container">
                <button
                    type="button"
                    className="session-enter-button"
                    onClick={() => enterRoom()}
                >
                    {t("enter")}
                </button>
                <button
                    type="button"
                    className="session-button"
                    onClick={() => leaveAlone()}
                >
                    {t("leave_alone")}
                </button>
            </div>
        </>
    );
};

export default EndSession;